import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiResponseModel, ApiVisa, Core2Config, PagingResponseModel } from '../../shared';
import { FinancialItemPricingListingDTO } from '../../../data-transfer-objects/financial-item-pricing-listing-response-dto.model';
import { FinancialItemPricingListingQueryCriteriaModel } from '../../../criteria/financial-item-pricing-listing-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemPricingListingService extends BaseApiTemplateService<FinancialItemPricingListingDTO> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-item-pricing-listings';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-item-pricing-listings' + '/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-item-pricing-listings' + '/backoffice-ep';
    this.httpClient = http;
  }

  upsertFinancialItemPricingListing(fiItemPricingDTO: FinancialItemPricingListingDTO, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl;
    return this.httpClient.post<ApiResponseModel<FinancialItemPricingListingDTO>>(url, fiItemPricingDTO, this.getHttpHeader(visa));
  }

  getBySnapshotQueryFi(dtoObject: FinancialItemPricingListingQueryCriteriaModel, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/query/snapshot';
    }
    const url = this.apiUrl;
    return this.httpClient.post<PagingResponseModel<FinancialItemPricingListingDTO>>(
      url, dtoObject, this.getHttpHeader(visa));
  }
}